import axios from "axios";

export const axiosMM = axios.create();

const withPXCookie = function(config) {
	const cookie = localStorage.getItem("pxcookie");
	if (cookie) {
		config.headers["x-px-cookies"] = cookie;
	}
	return config;
};

axiosMM.interceptors.request.use(withPXCookie);
